import { getToken, isCookieAuthEnabled, isTokenExpired } from "@/shared/lib/token";

// Sem token, omitir o header: enviar "Bearer null" faz o interceptor do servidor
// rejeitar o CONNECT e o stompjs reconectar em loop a cada 5s.
export function buildStompAuthHeaders(): Record<string, string> {
    const token = getToken();
    return token ? { Authorization: `Bearer ${token}` } : {};
}

export function canOpenStompConnection(): boolean {
    if (isCookieAuthEnabled()) {
        return true;
    }

    const token = getToken();
    return !!token && !isTokenExpired(token);
}
